import { useState, useEffect } from "react";
import {
  getAllGroups,
  getGroupsChildren,
  getAllGroupsList,
} from "../services/AppServices";
import { getGroupRelations } from "../services/MachineGroupServices";
import { errorStatusHandle } from "../utils/error-utils";
import { useSelector } from "react-redux";

const useGroupHook = () => {
  const [groupLevels, setGroupLevels] = useState([]);
  const [reload, setReload] = useState(0);
  const groupSetting = useSelector((s) => s.app_settings.machine_group);

  useEffect(() => {
    // const levels = ArrayUtils.range(1, 5).map((level) => {
    //   if (groupSetting[`group_${level}`]?.active) {
    //     return { value: level, label: groupSetting[`group_${level}`]?.name };
    //   }
    // });
    const levels = [];
    for (let level = 1; level <= 5; level++) {
      if (groupSetting[`group_${level}`]?.active) {
        levels.push({
          value: level,
          label: groupSetting[`group_${level}`]?.name,
        });
      }
    }
    setGroupLevels(levels);
  }, [reload, groupSetting]);

  return {
    groupLevels,
    setGroupLevels,
    reload,
    setReload,
  };
};

const useGroupRelation = (level, reload) => {
  const [groupRelations, setGroupRelations] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [orderList, setOrderList] = useState({
    group_1: 0,
    group_2: 0,
    group_3: 0,
    group_4: 0,
    group_5: 0,
    status: 0,
  });
  useEffect(() => {
    let data = {
      page: page,
      per_page: perPage,
      ...orderList,
    };
    if (level !== 0) {
      getGroupRelations(level, data)
        .then((reponse) => {
          setGroupRelations(reponse.data);
          setCount(reponse.count);
          setNumPages(reload.num_pages);
        })
        .catch((e) => {
          errorStatusHandle(e);
        });
    }
  }, [level, reload, page, perPage, orderList]);
  return {
    groupRelations,
    page,
    perPage,
    orderList,
    count,
    numPages,
    setGroupRelations,
    setPage,
    setPerPage,
    setOrderList,
    setCount,
    setNumPages,
  };
};

export { useGroupHook, useGroupRelation };
